export enum MsoTriState {
    msoCTrue = 1,
    msoFalse = 0,
    msoTriStateMixed = -2,
    msoTriStateToggle = -3,
    msoTrue = -1,
}
